import { render, staticRenderFns } from "./public-pop.vue?vue&type=template&id=b6b7ce1c&scoped=true&"
import script from "./public-pop.vue?vue&type=script&lang=js&"
export * from "./public-pop.vue?vue&type=script&lang=js&"
import style0 from "./public-pop.vue?vue&type=style&index=0&id=b6b7ce1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b7ce1c",
  null
  
)

export default component.exports